import type { ErrorInfo } from "react";
import React from "react";
import type { IResponse } from "App/Modules/Models";
import type { ErrorProps } from "./Error";
import { Error } from "./Error";

export type ErrorBoundaryProps = Omit<ErrorProps, "error"> & {
    error?: IResponse<void> | Error;
    hideErrorMessage?: boolean;
    unmountChildrenOnError?: boolean;
};

type State = {
    error: Error;
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
    constructor(props) {
        super(props);
        this.state = {
            error: undefined,
        };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // eslint-disable-next-line
        console.error("Irisity error boundary caught error.", error, errorInfo);
    }

    static getDerivedStateFromError(error: Error) {
        // Return object will update properties of this.state
        return {
            error,
        };
    }
    render() {
        const { hideErrorMessage, unmountChildrenOnError, error: propsError, ...otherProps } = this.props;

        const error = propsError || this.state.error;

        if (error) {
            return (
                <div className="error-boundary">
                    {!this.props.hideErrorMessage && <Error error={error} {...otherProps} />}

                    {!this.props.unmountChildrenOnError && (
                        <ErrorBoundary error={error} {...otherProps} unmountChildrenOnError hideErrorMessage>
                            {this.props.children}
                        </ErrorBoundary>
                    )}
                </div>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}
